import { request } from 'api/http';
import {
  AUTH_API_V1_URL_CHANGE_PASSWORD,
  AUTH_API_V1_VERIFICATION_PATH,
} from './constants';
import { ChangePasswordArgs } from './types';

export async function changePassword(args: ChangePasswordArgs) {
  await request.post<void>(AUTH_API_V1_URL_CHANGE_PASSWORD, args, {
    omitBearerPrefix: true,
  });
}

export async function resendVerification(userId: number) {
  await request.post<void>(
    AUTH_API_V1_VERIFICATION_PATH,
    {
      userId,
    },
    {
      omitBearerPrefix: true,
    },
  );
}
